// パスワード入力欄ごとに表示するエラーのキー対応表。
// 値はクライアント側検証のキーと、サーバー（administrators/update.php）が返すキーの両方。
// login_password_current_password は「現在のパスワード」欄のエラーで prefix が login_password と
// 重なるため、prefix 一致ではなく明示的なキー列挙で対応付ける（issue #31852）。
const PASSWORD_FIELD_ERROR_KEYS = {
  passwordOld: ['password_old', 'login_password_current_password'],
  passwordNew: [
    'password_new',
    'login_password', // 新パスワードポリシーのフラグOFF時（validate::password）のキー。フィーチャーフラグ strict_administrator_password_policy を削除したら不要になるので一緒に削除する
    'login_password_same_as_login_id',
    'login_password_min_password_length',
    'login_password_max_password_length',
    'login_password_ascii_password',
    'login_password_character_types_required_password',
    'login_password_compromised_password',
  ],
  passwordConfirm: ['password_confirm'],
};

/**
 * $scope.errors（キー→メッセージ）を入力欄ごとのエラーと上部バナー用エラーに振り分ける。
 * パスワード変更画面と更新モーダルで共通の配線（passwordCtrl.js のメールアドレス欄と同じパターン）。
 * 画面にある欄だけを fieldNames で渡す。渡さなかった欄のキーは上部バナーに出す。
 * @param {*} $scope
 * @param {Array<string>} fieldNames
 */
export function setupPasswordFieldErrors($scope, fieldNames = Object.keys(PASSWORD_FIELD_ERROR_KEYS)) {
  $scope.fieldErrors = { passwordOld: '', passwordNew: '', passwordConfirm: '' };
  // codmon-input-text の invalid は =?（双方向バインディング）で受けているため、
  // 代入できない式を渡すと書き戻し発生時に $compile:nonassign エラーになりうる。真偽値の変数で渡す
  $scope.passwordOldInvalid = false;
  $scope.passwordNewInvalid = false;
  $scope.passwordConfirmInvalid = false;
  $scope.generalErrors = [];

  $scope.$watchCollection('errors', (errors) => {
    const fieldKeySet = {};
    angular.forEach(PASSWORD_FIELD_ERROR_KEYS, (keys, field) => {
      if (!fieldNames.includes(field)) {
        return;
      }
      const messages = [];
      keys.forEach((key) => {
        fieldKeySet[key] = true;
        if (errors && errors[key]) {
          messages.push(errors[key]);
        }
      });
      // 複数ルール違反は改行で連結し、codmon-input-text 側で複数行表示する
      $scope.fieldErrors[field] = messages.join('\n');
    });
    $scope.passwordOldInvalid = !!$scope.fieldErrors.passwordOld;
    $scope.passwordNewInvalid = !!$scope.fieldErrors.passwordNew;
    $scope.passwordConfirmInvalid = !!$scope.fieldErrors.passwordConfirm;

    // どの欄にも紐づかないキーだけ従来どおり上部バナーに出す
    const generalErrors = [];
    angular.forEach(errors, (message, key) => {
      if (!fieldKeySet[key] && message) {
        generalErrors.push(message);
      }
    });
    $scope.generalErrors = generalErrors;
  });

  // 入力し直したら該当欄のエラーを消す
  const clearFieldErrorsOnInput = (modelName, field) => {
    if (!fieldNames.includes(field)) {
      return;
    }
    $scope.$watch(modelName, (newVal, oldVal) => {
      if (newVal === oldVal || !$scope.errors) {
        return;
      }
      PASSWORD_FIELD_ERROR_KEYS[field].forEach((key) => {
        delete $scope.errors[key];
      });
    });
  };
  clearFieldErrorsOnInput('login_password_old', 'passwordOld');
  clearFieldErrorsOnInput('login_password', 'passwordNew');
  clearFieldErrorsOnInput('login_password_confirm', 'passwordConfirm');
}
